module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/1/1-69e7c127d91d44c28b17cc5232b64caa.jpg";